import VueMask from 'v-mask';
import Vue from 'vue';

Vue.use(VueMask);
